import { render, staticRenderFns } from "./financeiro-tabela-regras-valores-fixos.vue?vue&type=template&id=4c6b84b5"
import script from "./financeiro-tabela-regras-valores-fixos.vue?vue&type=script&lang=ts"
export * from "./financeiro-tabela-regras-valores-fixos.vue?vue&type=script&lang=ts"
import style0 from "./financeiro-tabela-regras-valores-fixos.vue?vue&type=style&index=0&id=4c6b84b5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports